import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import { bikeNumToEnumStatuses } from "data/bike-numeric-statuses";
import findFilterValue from "helpers/find-filter-value";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import { triggerFilters, triggerGetActions } from "actions/bike-scan-trigger/actions";

class Filters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            filters: {}
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);

        this.props.triggerFilters();
        this.props.triggerGetActions();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.totalCount !== this.props.totalCount) {
            return true;
        } else if (nextState.isOpen !== this.state.isOpen) {
            return true;
        } else if (!_.isEqual(nextState.filters, this.state.filters)) {
            return true;
        } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
            return true;
        } else if (!_.isEqual(nextProps.actions, this.props.actions)) {
            return true;
        }
        return false;
    }

    handleSearch = () => {
        const { filters } = this.state;
        const filtersToArray = [];
        Object.keys(filters)
            .forEach(name => {
                if (Object.keys(filters[name]).length) {
                    filtersToArray.push(filters[name]);
                }
            });
        this.props.handleSearch(filtersToArray);
    };

    handleReset = () => {
        this.setState({
            filters: {}
        }, this.props.handleReset);
    };

    handleChangeFilter = (name, valueObject) => {
        const { filters } = this.state;
        filters[name] = valueObject;
        this.setState({
            filters
        });
    };

    render() {
        const {
            activeFilters,
            totalCount,
            filters,
        } = this.props;
        const {
            isOpen
        } = this.state;

        return (
            <Card className="w-100 mb-2 rounded-0">
                <FilterHeader
                    title={
                        <div>
                            Bike/User Trigger History
                        </div>
                    }
                    totalCount={totalCount}
                    isOpen={isOpen}
                    onToggle={(status) => this.setState({ isOpen: status })}
                />
                <Card.Body className="p-0">
                    <Collapse in={isOpen} className="p-3" timeout={0}>
                        <div className="row">
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="id"
                                    placeholder="ID"
                                    filterType="text"
                                    defaultValue=""
                                    onChange={this.handleChangeFilter}
                                    searchOperation={filters.id || [filterTypes.EQUALS.value]}
                                    value={findFilterValue("id", activeFilters)}
                                />
                            </div>
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="bike"
                                    placeholder="Bike"
                                    filterType="text"
                                    onChange={this.handleChangeFilter}
                                    searchOperation={filters.bike || [filterTypes.EQUALS.value]}
                                    value={findFilterValue("bike", activeFilters)}
                                />
                            </div>
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="bikeStatus"
                                    placeholder="Bike Status"
                                    filterType="select_multiple"
                                    filterTypeOptions={Object.keys(bikeNumToEnumStatuses)
                                        .map(key => ({
                                            label: bikeNumToEnumStatuses[key],
                                            value: bikeNumToEnumStatuses[key],
                                        }))}
                                    onChange={this.handleChangeFilter}
                                    searchOperation={filters.bikeStatus || [filterTypes.IN.value]}
                                    value={findFilterValue("bikeStatus", activeFilters)}
                                />
                            </div>
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="user"
                                    placeholder="User"
                                    filterType="text"
                                    onChange={this.handleChangeFilter}
                                    searchOperation={filters.user || [filterTypes.EQUALS.value]}
                                    value={findFilterValue("user", activeFilters)}
                                />
                            </div>
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="date"
                                    placeholder="Date"
                                    filterType="date"
                                    onChange={this.handleChangeFilter}
                                    searchOperation={[filterTypes.MORE.value, filterTypes.LESS.value]}
                                    value={findFilterValue("date", activeFilters)}
                                />
                            </div>

                            <div className="col-12 col-md-3 mb-3 offset-md-6">
                                <div
                                    className="d-flex justify-content-between justify-content-md-end">
                                    <button
                                        className="btn btn-warning btn-sm ml-2"
                                        onClick={this.handleReset}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success btn-sm ml-2"
                                        onClick={this.handleSearch}
                                    >
                                        Load
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </Card.Body>
            </Card>
        );
    }
}

Filters.defaultProps = {
    activeFilters: []
};

Filters.propTypes = {
    activeFilters: PropTypes.array.isRequired,
    handleSearch: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
    filters: state.bikeScanTrigger.filters,
    actions: state.bikeScanTrigger.actions,
});

const mapStateToDispatch = dispatch => ({
    triggerFilters: bindActionCreators(triggerFilters, dispatch),
    triggerGetActions: bindActionCreators(triggerGetActions, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Filters);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-trigger-history/filters.js